import { NavLink } from 'react-router-dom';
import { Label, Tab } from 'semantic-ui-react';
import React from 'react';
import sumBy from 'lodash/sumBy';
import { getString } from '../../utils';
import NetworkingContactSearch from '../tabs/NetworkingContactSearch';
import NetworkingChat from '../tabs/NetworkingChat';
import {
  allChatsList,
  hasActiveChats,
  invitesThatIDidntTreat,
} from '../store/networking.selectors';
import NetworkingInvites from '../tabs/NetworkingInvites';
import { getUserUnreadCount } from '../store/networking.helpers';
import { InviteModes } from '../InviteModes';
import { DEFAULT_INVITE_MODE } from '../InviteModes.hooks';

const translationRoot = 'networking';
export const tabsFromReduxState = (inviteMode = DEFAULT_INVITE_MODE) => (state) => {
  const invites = invitesThatIDidntTreat(state);
  const chats = allChatsList(state);
  const unreadCount = sumBy(chats, getUserUnreadCount);
  const tabs = [
    {
      menuItem: {
        as: NavLink,
        id: 'search',
        content: getString(`${translationRoot}.search`),
        to: '/networking',
        exact: true,
        key: 'search',
      },
      render: () => (
        <Tab.Pane key="Search" as="div">
          <NetworkingContactSearch />
        </Tab.Pane>
      ),
    },
    inviteMode === InviteModes.REQUEST && {
      menuItem: {
        as: NavLink,
        id: 'invites',
        content: (
          <>
            {getString(`${translationRoot}.my-invites.title`)}
            {invites.length > 0 && <Label color="blue">{invites.length}</Label>}
          </>
        ),
        to: '/networking/invites',
        exact: true,
        key: 'invites',
      },
      render: () => (
        <Tab.Pane key="Invites" as="div">
          <NetworkingInvites />
        </Tab.Pane>
      ),
    },
  ].filter(Boolean);
  const hasChats = hasActiveChats(state);
  if (hasChats) {
    tabs.push({
      menuItem: {
        as: NavLink,
        id: 'chat',
        content: (
          <>
            {getString(`${translationRoot}.chats`)}
            {!!unreadCount && <Label color="blue">{unreadCount}</Label>}
          </>
        ),
        to: '/networking/chats',
        key: 'chats',
      },
      render: () => (
        <Tab.Pane key="Chats" as="div" className="NetworkingScreen--ChatContainer">
          <NetworkingChat />
        </Tab.Pane>
      ),
    });
  }

  return tabs;
};
